import DownEmoji from "@modules/chat/icons/reactions/downEmoji.svg"
import FistEmoji from "@modules/chat/icons/reactions/fistEmoji.svg"
import MdrEmoji from "@modules/chat/icons/reactions/mdrEmoji.svg"
import StrongEmoji from "@modules/chat/icons/reactions/strongEmoji.svg"
import UpEmoji from "@modules/chat/icons/reactions/upEmoji.svg"
import { ReactionType } from "@modules/chat/reactionTypes"
import type { ReactionOptions } from "stream-chat-react"

export const customReactions: ReactionOptions = [
  {
    type: ReactionType.FIST,
    name: ReactionType.FIST,
    Component: () => <img src={FistEmoji} style={{ height: 20, width: 20 }} />,
  },
  {
    type: ReactionType.STRONG,
    name: ReactionType.STRONG,
    Component: () => <img src={StrongEmoji} style={{ height: 20, width: 20 }} />,
  },
  {
    type: ReactionType.UP,
    name: ReactionType.UP,
    Component: () => <img src={UpEmoji} style={{ height: 20, width: 20 }} />,
  },
  {
    type: ReactionType.DOWN,
    name: ReactionType.DOWN,
    Component: () => <img src={DownEmoji} style={{ height: 20, width: 20 }} />,
  },
  {
    type: ReactionType.HAHA,
    name: ReactionType.HAHA,
    Component: () => <img src={MdrEmoji} style={{ height: 20, width: 20 }} />,
  },
]
